<template>
    <v-app id="userLayout">
        <v-navigation-drawer
                v-model="drawer"
                :clipped="$vuetify.breakpoint.lgAndUp"
                fixed
                app
        >
            <v-list>
                <v-list-tile to="/admin/">
                    <v-list-tile-action>
                        <v-icon class="notranslate">home</v-icon>
                    </v-list-tile-action>
                    <v-list-tile-content>
                        <v-list-tile-title>
                            Главная
                        </v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
                <v-divider></v-divider>




                <template v-for="item in items">
                    <v-layout v-if="item.heading" :key="item.heading" row align-center>
                        <v-flex xs6>
                            <v-subheader v-if="item.heading">
                                {{ item.heading }}
                            </v-subheader>
                        </v-flex>
                        <v-flex xs6 class="text-xs-center">
                            <a href="#!" class="body-2 black--text">EDIT</a>
                        </v-flex>
                    </v-layout>
                    <v-list-group
                            v-else-if="item.children"
                            :key="item.text"
                            v-model="item.model"
                            :prepend-icon="item.model ? item.icon : item['icon-alt']"
                            append-icon=""
                            class="notranslate"
                    >
                        <template v-slot:activator>
                            <v-list-tile>
                                <v-list-tile-content>
                                    <v-list-tile-title>
                                        {{ item.text }}
                                    </v-list-tile-title>
                                </v-list-tile-content>
                            </v-list-tile>
                        </template>
                        <v-list-tile v-for="(child, i) in item.children" :key="i" :to="child.to"
                                     @click="item.click | (()=>{})">
                            <v-list-tile-action>
                                <v-icon class="notranslate">{{ child.icon }}</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content>
                                <v-list-tile-title>
                                    {{ child.text }}
                                </v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-list-group>
                    <v-list-tile v-else :key="item.text" :to="item.to" @click="item.click | (()=>{})">
                        <v-list-tile-action>
                            <v-icon class="notranslate">{{ item.icon }}</v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                            <v-list-tile-title>
                                {{ item.text }}
                            </v-list-tile-title>
                        </v-list-tile-content>
                    </v-list-tile>
                </template>
            </v-list>



        </v-navigation-drawer>
        <v-toolbar
                :clipped-left="$vuetify.breakpoint.lgAndUp"
                color="blue darken-3"
                dark
                app
                fixed
        >
            <v-toolbar-side-icon class="notranslate" @click.stop="drawer = !drawer" v-if="true"></v-toolbar-side-icon>
            <v-toolbar-title>
                <v-avatar size="32px" @click.stop="drawer = !drawer">
                    <img src="/media/logo-mobile.png" alt="Zenome">
                </v-avatar>
                <span class="hidden-sm-and-down notranslate">&nbsp; My Zenome</span>
            </v-toolbar-title>
            <v-spacer></v-spacer>
            <v-btn flat class="" to="/home/profile">
                <span v-if="$vuetify.breakpoint.mdAndUp">{{$store.state.user.name}}</span>
                <v-icon class="notranslate" right>account_circle</v-icon>
            </v-btn>
                 <v-btn icon @click="authLogout">
                <v-icon class="notranslate">exit_to_app</v-icon>
            </v-btn>
        </v-toolbar>
        <v-content>
            <v-container fluid2 fill-height2>
                <router-view/>
            </v-container>
        </v-content>


    </v-app>
</template>

<script>
    export default {
        name: "MainLayout",
        methods: {
            testAuth: function () {
                this.$http.get('/profile', {data: {}}).then(function (response) {
                    // eslint-disable-next-line
                    console.log(response);
                });
            },
            authLogout: function () {
                var this_ = this;
                this.$store.dispatch('logout', {}).then(function () {
                    this_.response = null
                    this_.$router.push('/')
                })
            }
        },
        data: () => ({
            dialog: false,
            drawer: null,
            items2: [
                {icon: 'contacts', text: 'Contacts'},
                {icon: 'history', text: 'Frequently contacted'},
                {icon: 'content_copy', text: 'Duplicates'},
                {
                    icon: 'keyboard_arrow_up',
                    'icon-alt': 'keyboard_arrow_down',
                    text: 'Labels',
                    model: true,
                    children: [
                        {icon: 'add', text: 'Create label'}
                    ]
                },
                {
                    icon: 'keyboard_arrow_up',
                    'icon-alt': 'keyboard_arrow_down',
                    text: 'More',
                    model: false,
                    children: [
                        {text: 'Import'},
                        {text: 'Export'},
                        {text: 'Print'},
                        {text: 'Undo changes'},
                        {text: 'Other contacts'}
                    ]
                },
                {icon: 'settings', text: 'Settings'},
                {icon: 'chat_bubble', text: 'Send feedback'},
                {icon: 'help', text: 'Help', to: '/home/help'},
                {icon: 'phonelink', text: 'App downloads'},
                {icon: 'keyboard', text: 'Go to the old version'}
            ],
            items: [
                {
                    icon: 'keyboard_arrow_up',
                    'icon-alt': 'keyboard_arrow_down',
                    text: 'Тесты',
                    model: false,
                    children: [
                        {icon: 'list', text: 'Список тестов', to: '/admin/tests/list'},
                        {icon: 'add', text: 'Зарегистрировать тест', to: '/admin/tests/reg'}
                    ]
                },
                {
                    icon: 'keyboard_arrow_up',
                    'icon-alt': 'keyboard_arrow_down',
                    text: 'Отчеты',
                    model: true,
                    children: [
                      {icon: 'list', text: 'Список отчетов', to: '/admin/reports/list'},
                      // {icon: 'list', text: 'Список Г отчетов', to: '/admin/reports/germinal-list'},
                      {icon: 'add', text: 'Зарегистрировать отчет', to: '/admin/reports/reg'}
                    ]
                },
              {
                icon: 'keyboard_arrow_up',
                'icon-alt': 'keyboard_arrow_down',
                text: 'Регистрация ритейл тестов',
                model: true,
                children: [
                  {icon: 'list', text: 'Список тестов', to: '/admin/retail-reg-data/list'},
                ]
              },

              {icon: 'help', text: 'Help', to: '/admin/help'}
            ]
        }),
        props: {
            source: String
        }


    }
</script>

<style scoped>

</style>
